import { Container, Flex, FloraButton } from '@grupoboticario/flora-react';
import { StarOutlineIcon } from '@grupoboticario/flora-react-icons';

import { ResponsiveFloraTypography } from 'components';

import Styles from './ResaleIntention.styles';
import { useLoyaltyIncentiveCampaign } from '../../hooks';

export const ResaleIntention = () => {
  const { data: incentiveCampaign } = useLoyaltyIncentiveCampaign();

  const redirectToHomePage = () => {
    window.location.replace('/');
  };

  return (
    <Styles.Wrapper data-autotagging-flora-section='campanha_de_incentivos'>
      <Container size='medium'>
        <Styles.Content gap='$6' direction='column' align='center'>
          <StarOutlineIcon color='$nonInteractiveEmphasis' size={60} />
          <ResponsiveFloraTypography fontSize='subtitle' fontWeight='bold'>
            Aproveite todas as vantagens incríveis da campanha de {incentiveCampaign?.pageTitle}.
          </ResponsiveFloraTypography>
          <ResponsiveFloraTypography color='$nonInteractiveAuxiliar'>
            Faça seu primeiro pedido e volte para participar da campanha. Prêmios imperdíveis te
            aguardam!
          </ResponsiveFloraTypography>
        </Styles.Content>
        <Flex justify='center'>
          <FloraButton
            onClick={redirectToHomePage}
            autotagging-flora='on'
            data-flora='button'
            data-flora-text='realizar-primeiro-pedido'
            styleSemantic='conversion'
          >
            <ResponsiveFloraTypography fontWeight='bold' fontSize='bodySmallStandard'>
              Realizar primeiro pedido
            </ResponsiveFloraTypography>
          </FloraButton>
        </Flex>
      </Container>
    </Styles.Wrapper>
  );
};
